<script setup lang="ts">
import { isEmpty } from 'es-toolkit/compat'

definePageMeta({
    hidePromotions: true,
})

const { site } = useCoreConfig()

// SEO - START
const { data: pageData } = await usePageData('kundeservice')

const { getHead, getSeoMeta } = useStrapiSeo(
    pageData.value?.seo || {
        metaTitle: `${site.title} Kundeservice Kontakt | Telefon, chat og email`,
        metaDescription: `Vores kundeservice er klar til at hjælpe dig med tekniske problemer og spørgsmål alle ugens dage. Se også vores FAQ på ${site.name}.`
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div class="kundeservice">
        <SidebarContainer />
        <LazyNimbusStrapiDynamicRenderer
            v-if="!isEmpty(pageData?.dynamicContent)"
            :content="pageData?.dynamicContent"
            :max-width="1024"
        />
    </div>
</template>
